import React, { useContext, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import jwt, { jwtDecode } from 'jwt-decode';
import { PromiseSesionContext } from '../machines/ErrorMachine';
import { nonRoutes, clientRoutes, adminRoutes } from '../routes/Routes';
import { Route } from '../models/Route';
import { User } from '../models/User';

interface Props {
  children: React.ReactNode;
}

const RolGuard = ({ children }: Props) => {
  const {sesion, sendSesion} = useContext(PromiseSesionContext);
  const navigate = useNavigate();
  const location = useLocation(); // Escucha cambios de ruta

  // 1. Determinar las rutas permitidas según el rol actual
  const allowedRoutes = useMemo(() => {
    switch (sesion.context.rol) {
      case "cliente": return clientRoutes;
      case "admin": return adminRoutes;
      default: return nonRoutes;
    }
  }, [sesion.context.rol]);

  // 2. Verificar si la ruta actual es permitida
  const isRouteAllowed = useMemo(() => {
    return allowedRoutes.some((r: Route) => {
      if (r.regex) return r.regex.test(location.pathname);
      return r.path === location.pathname;
    });
  }, [location.pathname, allowedRoutes]);

  // 3. Inicialización de sesión (Solo al montar)
useEffect(() => {
  const token = localStorage.getItem("token");
  
  // Avisamos a la máquina que estamos verificando para bloquear redirecciones
  sendSesion({ type: "VERIFYING" }); 

      console.log("Tipo de sendSesion:", typeof sendSesion, sendSesion);

  if (token) {
    try {
      const user: any = jwtDecode(token);
      // Importante: Asegúrate de que el nombre de la propiedad coincida (role_name vs role)
      sendSesion({ type: "AUTHORIZED", data: { user, rol: user?.role_name } });
    } catch (err) {


      console.log("error", err)
      sendSesion({type:"UNAUTHORIZED"});
    }
  } else {
    sendSesion({type:"UNAUTHORIZED"});
  }
}, [sendSesion]);

  // 4. Manejo de Redirecciones
useEffect(() => {
  // CLAVE: Si la máquina está verificando el token, NO hagas nada todavía.
  // También asegúrate de que tu máquina tenga un estado inicial claro (ej. 'idle')
  if (sesion.matches("verifying") || sesion.matches("idle")) return;

  if (!isRouteAllowed) {
    // Solo redirigimos si ya sabemos con certeza que el rol NO tiene permiso
    if (sesion.context.rol === "admin") {
      navigate("/", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }
}, [isRouteAllowed, sesion.value, sesion.context.rol, navigate]);

  // Evitar parpadeos: si está verificando, podrías mostrar un loader
  if (sesion.matches("verifying")) {
    return null; // o <Loading />
  }

  return isRouteAllowed ? <>{children}</> : null;
};

export default RolGuard;